import React, { FC } from 'react';
import { StandardScopeProps } from './StandardScopeProps';
import StandardActivitiesForm from '../StandardActivitiesForm/StandardActivitiesForm';

export const DefaultStandardScope: FC<StandardScopeProps> =
    props =>
        <StandardActivitiesForm {...props} defaultActivitiesFilter={() => []}/>
;
